import { render, staticRenderFns } from "./DeleteJobButton.vue?vue&type=template&id=0928543e"
import script from "./DeleteJobButton.vue?vue&type=script&lang=js"
export * from "./DeleteJobButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports